import { JSX } from "react";
import { useTranslation } from "react-i18next";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, Tooltip } from "@mui/material";

const CopyToClipboard = ({
  data,
}: {
  data: string | undefined;
}): JSX.Element => {
  const { t } = useTranslation();

  if (!data) {
    return <></>;
  }

  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(data);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Tooltip title={t("WEG:tooltip.copyToClipboard")}>
      <Button onClick={handleCopy} sx={{ minWidth: "30px" }}>
        <ContentCopyIcon
          sx={{
            height: "20px",
          }}
        />
      </Button>
    </Tooltip>
  );
};

export default CopyToClipboard;
